import React, { useState, useEffect, useRef } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import FeedBackAction from "../../../Actions/FeedBackAction";
import FeedBackConstant from "../../../Constants/FeedBackConstants";
import feedBackStore from "../../../Stores/FeedBackStore";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import AddFeedBack from "./AddFeedBack";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { toast } from "react-toastify";
import CommonSearchBar from "../../ReusableComponent/CommonSearchBar";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
export default function FeedBackList() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [eventType, setEventType] = useState(null);
  const [callbackData, setCallbackData] = useState(null);
  const [egId, setEgId] = useState(null);
  const [equipmentGroupName, setequipmentGroupName] = useState("");
  const [feedBackList, setFeedBackList] = useState([]);
  const [resFeedBackList, setResFeedBackList] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [egList, setEgList] = useState([]);
  const eqIdRef = useRef("");
  const columns = [
    {
      field: "bezeichnung",
      headerName: localization.feedBack,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
  ];
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_FEEDBACK":
          eqIdRef.current = egId;
          setGlobalSpinner(true);
          const res = FeedBackAction.deleteFeedBack(data, egId);

          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  const closeAddEditfeedBackPopUpCallback = () => {
    setSelectedFeedback("");
  };
  //------------------------Get EquipmentGroup By Organisation start ----------------------

  const getEquipmentGroupByOrganisations = () => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getOrganisationsEquipmentGroup();
  };

  useEffect(() => {
    getEquipmentGroupByOrganisations();
    function getEquipmentGroupSuccess() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();

      if (res.length > 0) {
        // let eqlist = res.filter(
        //   (item) => item.location !== "" && item.location !== null
        // );
        let sortList = res.sort((a, b) =>
          a.werk > b.werk ? 1 : a.werk < b.werk ? -1 : 0,
        );

        setEgList(sortList);
        if (sortList.length > 0) {
          setEgId(sortList[0].id);
          setequipmentGroupName(sortList[0].bezeichnung);
        }
      } else {
        setEgList([]);
      }
    }
    function getEquipmentGroupFailure() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();

      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
      getEquipmentGroupSuccess,
    );
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
      getEquipmentGroupFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
        getEquipmentGroupSuccess,
      );
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
        getEquipmentGroupFailure,
      );
    };
  }, []);

  //------------------------Get EquipmentGroup By Organisation End ----------------------

  //------------------------Get FeedBack By EquipmentGroup start ----------------------

  function getFeedBackByEquipmentGroup(egId) {
    setGlobalSpinner(true);
    FeedBackAction.getFeedBackByEqGrp(egId);
  }

  useEffect(() => {
    if (egId !== null) {
      eqIdRef.current = egId;
      getFeedBackByEquipmentGroup(egId);
    }
    if (egId) {
      egList.map((item) => {
        if (item.id === egId) {
          setequipmentGroupName(item.bezeichnung);
        }
      });
    }
  }, [egId]);

  useEffect(() => {
    function getFeedBackResultSuccess() {
      const res = feedBackStore.getResult();

      if (res.length > 0) {
        setFeedBackList(res);
        setResFeedBackList(res);
      } else {
        setResFeedBackList([]);
        setFeedBackList([]);
      }
      setGlobalSpinner(false);
    }
    function getFeedBackResultFailure() {
      const res = feedBackStore.getResult();
      setGlobalSpinner(false);
    }
    feedBackStore.addChangeListener(
      FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS,
      getFeedBackResultSuccess,
    );
    feedBackStore.addChangeListener(
      FeedBackConstant.GET_FEEDBACK_LIST_FAILURE,
      getFeedBackResultFailure,
    );
    return () => {
      feedBackStore.removeChangeListener(
        FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS,
        getFeedBackResultSuccess,
      );
      feedBackStore.removeChangeListener(
        FeedBackConstant.GET_FEEDBACK_LIST_FAILURE,
        getFeedBackResultFailure,
      );
    };
  }, []);
  useEffect(() => {
    function getFeedBackSaveUpdateSuccess() {
      const res = feedBackStore.getResult();

      if (res) {
        commonUtils.hideModalPopUp("addFeedbackModalClose");
        toast.success(
          commonUtils.isEdit
            ? localization.feedBackEdit
            : localization.feedbackAdd,
        );
        getFeedBackByEquipmentGroup(eqIdRef.current);
      }
    }
    function getFeedBackSaveUpdateFailure() {
      const res = feedBackStore.getResult();
      toast.error(res);

      setGlobalSpinner(false);
    }
    feedBackStore.addChangeListener(
      FeedBackConstant.SAVE_UPDATE_FEEDBACK_SUCCESS,
      getFeedBackSaveUpdateSuccess,
    );
    feedBackStore.addChangeListener(
      FeedBackConstant.SAVE_UPDATE_FEEDBACK_FAILURE,
      getFeedBackSaveUpdateFailure,
    );
    return () => {
      feedBackStore.removeChangeListener(
        FeedBackConstant.SAVE_UPDATE_FEEDBACK_SUCCESS,
        getFeedBackSaveUpdateSuccess,
      );
      feedBackStore.removeChangeListener(
        FeedBackConstant.SAVE_UPDATE_FEEDBACK_FAILURE,
        getFeedBackSaveUpdateFailure,
      );
    };
  }, []);
  useEffect(() => {
    function getFeedBackDelSuccess() {
      const res = feedBackStore.getResult();

      toast.success(localization.feedBackDel);

      getFeedBackByEquipmentGroup(eqIdRef.current);
      setFeedBackList(null);
    }
    function getFeedBackDelFailure() {
      const res = feedBackStore.getResult();
      toast.error(res);

      setGlobalSpinner(false);
    }
    feedBackStore.addChangeListener(
      FeedBackConstant.DEL_FEEDBACK_SUCCESS,
      getFeedBackDelSuccess,
    );
    feedBackStore.addChangeListener(
      FeedBackConstant.DEL_FEEDBACK_FAILURE,
      getFeedBackDelFailure,
    );
    return () => {
      feedBackStore.removeChangeListener(
        FeedBackConstant.DEL_FEEDBACK_SUCCESS,
        getFeedBackDelSuccess,
      );
      feedBackStore.removeChangeListener(
        FeedBackConstant.DEL_FEEDBACK_FAILURE,
        getFeedBackDelFailure,
      );
    };
  }, []);

  const setCurrentFeedbackDetails = (row) => {
    setSelectedFeedback(row);
  };

  function RenderAddFeedBack() {
    return (
      <>
        <Button
          variant="outlined"
          id="addFeedBack"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addFeedback"
        >
          {localization.add}
        </Button>
      </>
    );
  }

  const handleAdd = () => {
    setSelectedFeedback("");
  };

  function RenderEditButton(props) {
    const feedBack = props.feedBack;
    eqIdRef.current = egId;
    return (
      <>
        <Button
          variant="outlined"
          id="editFeedBack"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addFeedback"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  function deleteFeedBackCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData(id);
    setEventType("DELETE_FEEDBACK");
  }
  function RenderDeleteButton(props) {
    const id = props.feedBackID;

    return (
      <>
        <Button
          variant="outlined"
          id="deleteFeedBack"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteFeedBackCallback(_idList);
  };
  //------------------------Get FeedBack By EquipmentGroup End ----------------------
  function handleSearch(_enterText) {
    const res = customizeFilter(resFeedBackList, _enterText, [
      "anlagegruppeId",
      "id",
    ]);
    setFeedBackList(res);
  }

  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: setCurrentFeedbackDetails,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddFeedBack />,
        onClick: handleAdd,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => setCurrentFeedbackDetails(params.row)}
        data-toggle="modal"
        data-target="#addFeedback"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div
        style={{ height: "100%", width: "100%", overflow: "auto" }}
        id="content"
      >
        {feedBackList && (
          <CustomDataGrid
            Title={localization.insSetting + " / " + localization.feedBack}
            renderParentComponent={
              <div className="form-group d-flex  align-items-center">
                <label htmlFor="equipmentGroupList" className="mr-3">
                  {localization.equipmentGroup}
                </label>
                <select
                  className="form-control"
                  id="equipmentGroupList"
                  name="equipmentGroupList"
                  required
                  value={egId}
                  onChange={(e) => {
                    setEgId(e.target.value);
                  }}
                >
                  <option value="0" disabled>
                    {localization.selectEquipmentGroup}
                  </option>
                  {egList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.bezeichnungsDisplay}
                      </option>
                    );
                  })}
                </select>
              </div>
            }
            columns={columns}
            rows={feedBackList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["bezeichnung"]}
            showCheckBox={true}
            gridTableHeight={"dataGridSmall"}
          />
        )}
      </div>
      <AddFeedBack
        feedBackDetails={selectedFeedback}
        eqID={egId}
        closeAddEditfeedBackPopUpCallback={closeAddEditfeedBackPopUpCallback}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
}
